import { useSelector } from 'react-redux';
import { ApplicationState } from '@idw-types/state';

export const useParamSelector = (selector: (state: ApplicationState, params: any) => any, params: any) => {
	return useSelector((state: ApplicationState) => selector(state, params));
}
